
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function OurPlace() {
  const img = useFadeIn({ direction: 'right' });
  const text = useFadeIn({ direction: 'up', delay: 200 });

  return (
    <section className="py-32 md:py-40 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className="order-2 md:order-1">
            <div
              ref={img.ref}
              className="aspect-[4/3] w-full overflow-hidden"
              style={img.style}
            >
              <img
                src="https://readdy.ai/api/search-image?query=A%20serene%20and%20minimalist%20dental%20clinic%20interior%20detail%20shot%20with%20natural%20lighting.%20Clean%20white%20surfaces%20with%20subtle%20textures%20soft%20shadows%20and%20a%20calm%20atmosphere.%20No%20people%20in%20the%20frame%20focusing%20on%20the%20peaceful%20and%20professional%20environment.%20Simple%20elegant%20design%20with%20plenty%20of%20negative%20space%20emphasizing%20tranquility%20and%20trust.%20Neutral%20color%20palette%20with%20warm%20natural%20light%20creating%20a%20welcoming%20yet%20sophisticated%20ambiance&width=800&height=600&seq=place001&orientation=landscape"
                alt="院内の様子"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          
          <div className="order-1 md:order-2" ref={text.ref} style={text.style}>
            <div className="space-y-10">
              <h2 className="text-2xl md:text-3xl font-normal text-gray-900 leading-relaxed tracking-wide font-serif">
                考える時間を、邪魔しない場所で。
              </h2>
              
              <div className="space-y-6 text-gray-700 text-base md:text-lg font-light leading-loose">
                <p>
                  moyuk SAPPORO は、<br />
                  札幌の中心にありながら、<br />
                  落ち着いて話ができる環境を大切にしています。
                </p>
                <p>
                  診療室は完全個室。<br />
                  周りを気にせず、自分のペースで相談できます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
